module.exports = __webpack_public_path__ + "img/app-logo.e38bfa55.png";